module.exports = __webpack_public_path__ + "static/media/product-image.b50154e2.webp";